import React, {

  useCallback,

  useContext,

  useEffect,

  useRef,

  useState,

} from "react";

import { Link, useNavigate } from "react-router-dom";

import MenuButton from "../MenuButton/MenuButton";

import { NoteState } from "../../context/notes/NoteState";

import UserServices from "../../UserServices/UserServices";

import Pagination from "react-js-pagination";

import "./NutritionClientDetails.css";



const FILTER_OPTIONS = [

  { value: "all", label: "All clients" },

  { value: "has_any", label: "With nutrition records" },

  { value: "missing_any", label: "No nutrition records yet" },

  { value: "meal_plan", label: "Has meal plan" },

  { value: "questionnaire", label: "Has questionnaire" },

  { value: "nutrition_assessment", label: "Has nutrition assessment" },

  { value: "appointments", label: "Has appointments" },

];



const RESOURCES = [

  {

    key: "meal_plans",

    label: "Meal plan",

    icon: "bi-calendar2-week",

    latestKey: "meal_plan_uuid",

    viewPath: (c) =>

      c.latest?.meal_plan_uuid

        ? `/detail-meal-plan/${c.latest.meal_plan_uuid}`

        : null,

    addPath: "/add-meal-plan",

    listPath: "/view-meal-plan",

  },

  {

    key: "questionnaires",

    label: "Assessment questionnaire",

    icon: "bi-clipboard2-pulse",

    latestKey: "questionnaire_id",

    viewPath: (c) =>

      c.latest?.questionnaire_id

        ? `/nutritionist-assessment-form/${c.latest.questionnaire_id}`

        : null,

    addPath: "/nutritionist-assessment-form/new",

    listPath: "/nutritionist-assessment-form",

    printOnView: true,

  },

  {

    key: "nutrition_assessments",

    label: "Nutrition assessment",

    icon: "bi-heart-pulse",

    latestKey: "nutrition_assessment_id",

    viewPath: (c) =>

      c.latest?.nutrition_assessment_id

        ? `/edit-nutrition-assessments/${c.latest.nutrition_assessment_id}`

        : null,

    addPath: "/nutrition-assessments",

    listPath: "/view-nutrition-assessments",

    hideForNutritionist: true,

  },

  {

    key: "appointments",

    label: "Appointments",

    icon: "bi-calendar-check",

    viewPath: () => "/nutrition/appointments",

    addPath: "/nutrition/appointments",

    listPath: "/nutrition/appointments",

    nutritionistOnly: true,

  },

];



const defaultAvatar = (name) => {

  const parts = (name || "?").trim().split(/\s+/);

  return (

    (parts[0]?.[0] || "").toUpperCase() + (parts[1]?.[0] || "").toUpperCase()

  );

};



export default function NutritionClientDetails() {

  const { state } = useContext(NoteState);

  const { branch_id, role } = state;

  const navigate = useNavigate();

  const clientDropdownRef = useRef(null);



  const [loading, setLoading] = useState(false);

  const [clients, setClients] = useState([]);

  const [allClients, setAllClients] = useState([]);

  const [filteredPickerClients, setFilteredPickerClients] = useState([]);

  const [clientSearchTerm, setClientSearchTerm] = useState("");

  const [showClientDropdown, setShowClientDropdown] = useState(false);

  const [selectedClientId, setSelectedClientId] = useState("");

  const [filter, setFilter] = useState("all");

  const [currentPage, setCurrentPage] = useState(1);

  const [limit] = useState(12);

  const [totalResults, setTotalResults] = useState(0);

  const [totalPages, setTotalPages] = useState(1);



  const filterClientsForPicker = useCallback((term, source) => {

    const list = source || [];

    const v = (term || "").trim().toLowerCase();

    if (!v) return list;

    return list.filter(

      (c) =>

        c.name.toLowerCase().includes(v) ||

        (c.phone && c.phone.includes(v)) ||

        (c.uid && String(c.uid).toLowerCase().includes(v)) ||

        (c.email && c.email.toLowerCase().includes(v))

    );

  }, []);



  const fetchAllClients = useCallback(async () => {

    if (!branch_id) return;

    try {

      const res = await UserServices.getClientsName(branch_id);

      if (res.status === 200 && res.data?.data) {

        const mapped = res.data.data.map((c) => ({

          id: c.id,

          uid: c.uid,

          name: `${c.first_name || ""} ${c.last_name || ""}`.trim(),

          phone: c.phone || "",

          email: c.email || "",

        }));

        setAllClients(mapped);

        setFilteredPickerClients(mapped);

      }

    } catch (err) {

      console.log(err);

    }

  }, [branch_id]);



  const fetchClients = useCallback(async () => {

    if (!branch_id) return;

    setLoading(true);

    try {

      const params = {

        branch_id,

        filter,

        limit,

        page: currentPage,

      };

      if (selectedClientId) {

        params.client_id = selectedClientId;

      }

      const res = await UserServices.getNutritionClientHub(params);

      if (res.status === 200 && res.data?.status) {

        const payload = res.data.data;

        const rows = Array.isArray(payload?.data)

          ? payload.data

          : Array.isArray(payload)

            ? payload

            : [];

        setClients(rows);

        setTotalResults(res.data.totalRecord ?? payload?.total ?? rows.length);

        setTotalPages(res.data.totalPages ?? payload?.last_page ?? 1);

      } else {

        setClients([]);

        setTotalResults(0);

        setTotalPages(1);

      }

    } catch (err) {

      console.log(err);

      setClients([]);

      setTotalResults(0);

      setTotalPages(1);

    }

    setLoading(false);

  }, [branch_id, selectedClientId, filter, limit, currentPage]);



  useEffect(() => {

    fetchAllClients();

  }, [fetchAllClients]);



  useEffect(() => {

    fetchClients();

  }, [fetchClients]);



  useEffect(() => {

    setCurrentPage(1);

  }, [selectedClientId, filter]);



  useEffect(() => {

    const handleClick = (e) => {

      if (

        clientDropdownRef.current &&

        !clientDropdownRef.current.contains(e.target)

      ) {

        setShowClientDropdown(false);

      }

    };

    document.addEventListener("mousedown", handleClick);

    return () => document.removeEventListener("mousedown", handleClick);

  }, []);



  const handleClientSearch = (e) => {

    const v = e.target.value;

    setClientSearchTerm(v);

    setShowClientDropdown(true);

    setFilteredPickerClients(filterClientsForPicker(v, allClients));

    if (!v.trim()) {

      setSelectedClientId("");

    }

  };



  const handleClientSelect = (client) => {

    setSelectedClientId(String(client.id));

    setClientSearchTerm(client.name);

    setShowClientDropdown(false);

    setFilter("all");

  };



  const handleClearSearch = () => {

    setClientSearchTerm("");

    setSelectedClientId("");

    setFilteredPickerClients(allClients);

    setShowClientDropdown(false);

  };



  const handleResetFilters = () => {

    setFilter("all");

    handleClearSearch();

  };



  const goWithClient = (path, client) => {

    navigate(path, {

      state: {

        clientId: client.id,

        clientName: client.full_name,

        fromClientHub: true,

      },

    });

  };



  const canAccessNutritionistRoutes =
    role === "10" || role === "1" || role === "3" || role === "11";

  const isNutritionist = role === "10";

  const activeFilterLabel =

    FILTER_OPTIONS.find((o) => o.value === filter)?.label || "All clients";

  const hasActiveFilters =

    filter !== "all" || selectedClientId || clientSearchTerm.trim();



  return (

    <div className="wrapper nutrition-client-hub">

      <main className="page-content customer-contnent">

        <div className="site-main-design">

          <MenuButton />



          <div className="card border-0 shadow-sm">

            <div className="card-header bg-white py-3 border-bottom">

              <div className="d-flex flex-wrap justify-content-between align-items-start gap-2">

                <div>

                  <h5 className="mb-1 fw-semibold">

                    <i className="bi bi-people-fill text-danger me-2" />

                    Clients Details

                  </h5>

                  <p className="text-muted small mb-0">

                    Nutrition overview — meal plans, assessments, questionnaires,

                    diet plans, and appointments per client.

                  </p>

                </div>

                {hasActiveFilters ? (

                  <button

                    type="button"

                    className="btn btn-outline-secondary btn-sm"

                    onClick={handleResetFilters}

                  >

                    <i className="bi bi-x-circle me-1" />

                    Reset filters

                  </button>

                ) : null}

              </div>

            </div>



            <div className="card-body">

              <div className="hub-filters-grid mb-4">

                <div className="hub-filter-field">

                  <label className="hub-filter-label" htmlFor="hub-client-search">

                    Search client

                  </label>

                  <div className="hub-filter-control">

                    <div className="position-relative w-100" ref={clientDropdownRef}>

                      <div className="input-group hub-input-group">

                      <span className="input-group-text bg-white">

                        <i className="bi bi-search" />

                      </span>

                      <input

                        id="hub-client-search"

                        type="text"

                        className="form-control"

                        placeholder="Browse all clients or type name, phone, ID..."

                        value={clientSearchTerm}

                        onChange={handleClientSearch}

                        onFocus={() => {

                          setShowClientDropdown(true);

                          setFilteredPickerClients(

                            filterClientsForPicker(clientSearchTerm, allClients)

                          );

                        }}

                        autoComplete="off"

                      />

                      {clientSearchTerm ? (

                        <button

                          type="button"

                          className="btn btn-outline-secondary hub-clear-btn"

                          onClick={handleClearSearch}

                        >

                          Clear

                        </button>

                      ) : null}

                    </div>

                    {showClientDropdown && filteredPickerClients.length > 0 ? (

                      <div className="client-picker-dropdown">

                        <div className="client-picker-meta">

                          {filteredPickerClients.length} of {allClients.length}{" "}

                          clients

                        </div>

                        {filteredPickerClients.map((c) => (

                          <button

                            key={c.id}

                            type="button"

                            className={`client-picker-item${

                              String(c.id) === String(selectedClientId)

                                ? " active"

                                : ""

                            }`}

                            onClick={() => handleClientSelect(c)}

                          >

                            <span className="client-picker-name">{c.name}</span>

                            <span className="client-picker-sub">

                              {[c.uid ? `ID: ${c.uid}` : null, c.phone]

                                .filter(Boolean)

                                .join(" · ")}

                            </span>

                          </button>

                        ))}

                      </div>

                    ) : null}

                    {showClientDropdown &&

                    allClients.length > 0 &&

                    filteredPickerClients.length === 0 ? (

                      <div className="client-picker-dropdown client-picker-empty">

                        No clients match your search

                      </div>

                    ) : null}

                    </div>

                  </div>

                </div>



                <div className="hub-filter-field">

                  <label className="hub-filter-label" htmlFor="hub-nutrition-filter">

                    Nutrition filter

                  </label>

                  <div className="hub-filter-control">

                    <select

                      id="hub-nutrition-filter"

                      className="form-select hub-filter-select"

                      value={filter}

                      onChange={(e) => setFilter(e.target.value)}

                    >

                      {FILTER_OPTIONS.filter(
                        (opt) =>
                          !(isNutritionist && opt.value === "nutrition_assessment")
                      ).map((opt) => (

                        <option key={opt.value} value={opt.value}>

                          {opt.label}

                        </option>

                      ))}

                    </select>

                  </div>

                </div>



                <div className="hub-filter-field hub-filter-count">

                  <label className="hub-filter-label">Total</label>

                  <div className="hub-filter-control">

                    <div className="hub-results-badge">

                      <span className="hub-results-count">{totalResults}</span>

                      <span className="hub-results-label">

                        {totalResults === 1 ? "client" : "clients"}

                      </span>

                    </div>

                  </div>

                </div>

              </div>



              {loading && !clients.length ? (

                <div className="text-center py-5">

                  <div className="spinner-border text-danger" role="status" />

                  <p className="text-muted mt-2 mb-0">Loading clients...</p>

                </div>

              ) : null}



              {!loading && clients.length === 0 ? (

                <div className="empty-state">

                  <i className="bi bi-person-x" />

                  <h6>No clients found</h6>

                  <p className="mb-0 small">

                    {filter !== "all"

                      ? `No clients match "${activeFilterLabel}". Try "All clients" or pick a client from the search list.`

                      : selectedClientId

                        ? "This client could not be loaded."

                        : "No active clients in this branch."}

                  </p>

                </div>

              ) : null}



              <div className="row g-4">

                {clients.map((client) => (

                  <div key={client.id} className="col-12 col-md-6 col-xl-4">

                    <article className="client-card">

                      <div className="client-card-header">

                        <div className="client-avatar-wrap">

                          {client.image ? (

                            <img src={client.image} alt={client.full_name} />

                          ) : (

                            <div className="client-avatar-placeholder">

                              {defaultAvatar(client.full_name)}

                            </div>

                          )}

                        </div>

                        <div className="client-meta flex-grow-1">

                          <span className="uid-badge">

                            ID: {client.uid || client.id}

                          </span>

                          <h6>{client.full_name}</h6>

                          {client.phone ? (

                            <div className="detail-line">

                              <i className="bi bi-telephone" />

                              {client.phone}

                            </div>

                          ) : null}

                          {client.gender ? (

                            <div className="detail-line">

                              <i className="bi bi-gender-ambiguous" />

                              {client.gender}

                            </div>

                          ) : null}

                          {client.email ? (

                            <div className="detail-line text-truncate">

                              <i className="bi bi-envelope" />

                              {client.email}

                            </div>

                          ) : null}

                        </div>

                      </div>



                      <div className="status-strip">

                        <div className="status-pills">

                          <span

                            className={`status-pill ${client.counts?.meal_plans ? "on" : "off"}`}

                            title="Meal plans"

                          >

                            Meals

                          </span>

                          <span

                            className={`status-pill ${client.counts?.questionnaires ? "on" : "off"}`}

                            title="Questionnaire"

                          >

                            Q&apos;nnaire

                          </span>

                          {!isNutritionist ? (
                          <span

                            className={`status-pill ${client.counts?.nutrition_assessments ? "on" : "off"}`}

                            title="Nutrition assessment"

                          >

                            Assessment

                          </span>
                          ) : null}

                          <span

                            className={`status-pill ${client.counts?.appointments ? "on" : "off"}`}

                            title="Appointments"

                          >

                            Appts

                          </span>

                        </div>

                        <div

                          className="completeness-bar"

                          title="Nutrition file completeness"

                        >

                          <span

                            style={{

                              width: `${client.nutrition_completeness || 0}%`,

                            }}

                          />

                        </div>

                      </div>



                      <div className="resource-section">

                        <h6>Quick actions</h6>

                        {RESOURCES.map((res) => {

                          if (

                            res.nutritionistOnly &&

                            !canAccessNutritionistRoutes

                          ) {

                            return null;

                          }

                          if (res.hideForNutritionist && isNutritionist) {

                            return null;

                          }

                          const count = client.counts?.[res.key] || 0;

                          const viewHref = res.viewPath(client);

                          const hasRecord = count > 0;



                          return (

                            <div key={res.key} className="resource-block">

                              <div className="resource-label">

                                <span>

                                  <i

                                    className={`bi ${res.icon} me-1 text-danger`}

                                  />

                                  {res.label}

                                </span>

                                <span className="count">

                                  {hasRecord ? `${count} on file` : "Not added"}

                                </span>

                              </div>

                              <div className="resource-actions">

                                {hasRecord && viewHref ? (

                                  <Link

                                    to={viewHref}

                                    className="btn btn-outline-primary btn-sm"

                                    state={{

                                      clientId: client.id,

                                      clientName: client.full_name,

                                    }}

                                  >

                                    <i className="bi bi-eye me-1" />

                                    View

                                  </Link>

                                ) : null}

                                {hasRecord && res.printOnView && viewHref ? (

                                  <Link

                                    to={viewHref}

                                    className="btn btn-outline-secondary btn-sm"

                                    title="Open form to print / download PDF"

                                  >

                                    <i className="bi bi-printer me-1" />

                                    Print

                                  </Link>

                                ) : null}

                                <button

                                  type="button"

                                  className="btn btn-outline-success btn-sm"

                                  onClick={() => goWithClient(res.addPath, client)}

                                >

                                  <i className="bi bi-plus-lg me-1" />

                                  Add

                                </button>

                                {res.listPath ? (

                                  <Link

                                    to={res.listPath}

                                    className="btn btn-outline-dark btn-sm"

                                  >

                                    <i className="bi bi-list-ul me-1" />

                                    All

                                  </Link>

                                ) : null}

                              </div>

                            </div>

                          );

                        })}

                      </div>

                    </article>

                  </div>

                ))}

              </div>

            </div>



            {totalResults > limit && totalPages > 1 ? (

              <div className="card-footer bg-transparent d-flex justify-content-between align-items-center flex-wrap gap-2">

                <small className="text-muted">

                  Showing {(currentPage - 1) * limit + 1}–

                  {Math.min(currentPage * limit, totalResults)} of {totalResults}

                </small>

                <Pagination

                  activePage={currentPage}

                  itemsCountPerPage={limit}

                  totalItemsCount={totalResults}

                  pageRangeDisplayed={5}

                  onChange={(page) => setCurrentPage(page)}

                  itemClass="page-item"

                  linkClass="page-link"

                  innerClass="pagination pagination-sm mb-0"

                  firstPageText="«"

                  lastPageText="»"

                />

              </div>

            ) : null}

          </div>

        </div>

      </main>

      <div className={`loader ${loading ? "in" : ""}`}>

        <div className="spinner-border main-spin" />

      </div>

    </div>

  );

}


